import React from 'react';
import useTimeAgo from '@rooks/use-time-ago';

export const TimeAgo = (props) => {
  const { date, className } = props;
  const jsdate = new Date(date);
  const timeAgo = useTimeAgo(jsdate.getTime() - 60000, {
    locale: 'EN',
  });

  return <span className={className}>{timeAgo}</span>;
};
